import { Box, Button, Container, Grid, Input, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Select, MenuItem, RadioGroup, FormControlLabel, TextField  } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect, useState } from "react";
import api from "../../../utils/api_v2";
import LodingData from "../../../utils/LodingData";

import useStressStore from "../../../store/stressStores";
import { useLocation, useNavigate } from "react-router-dom";

import $ from 'jquery';
import tabbg from "../../../assets/images/tab_01.png"

const StressAnswer = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();
  const location = useLocation();
  
  // hra 항목 추가 요소
  const [hraQ4, setHraQ4] = useState<string | null>(null);
  const [relation, setRelation] = useState('');
  const [age, setAge] = useState('');
  const [disease, setDisease] = useState('');

  useEffect(() => {
    getQuestionsList();

    return () => {
      // storeData.clear();
    }
  }, [])

  useEffect(() => {

    genRowspan('category');

  }, [storeData.questionsList])

  function getQuestionsList() {
    let userId: any = localStorage.getItem('userID');

    LodingData(() => api.get(`customer/api/v2/surveys/${location.state.survey_uid}/assigns/${location.state.assigned_uid}`, { headers: { 'userId': userId } })
      .then(res => {
        // console.log(res);
        // storeData.setQuestionsList(res.data.data);

        const tempList = [];
        for (let i = 0; i < res.data.data.info.length; i++) {
          const { category, question } = res.data.data.info[i];
          const tempObj: any = {};
          tempObj.category = category.name;
          tempObj.category_uid = category.uid;
          tempObj.category_number = category.number;

          tempObj.number = question.number;
          tempObj.title = question.title;
          tempObj.question_uid = question.uid;
          tempObj.type = question.type;

          tempObj.strongly_disagree = question.option.strongly_disagree;
          tempObj.disagree = question.option.disagree;
          tempObj.agree = question.option.agree;
          tempObj.strongly_agree = question.option.strongly_agree;

          tempList.push(tempObj);
        }

        storeData.setQuestionsList(tempList);
      })
      .catch(err => {
        console.log(err);
      }));
  }

  // 카테고리 rowspan 함수
  const genRowspan = (className: string) => {
    const elements = Array.from(
      document.querySelectorAll(`.${className}`)
    ) as HTMLTableCellElement[];
    let lastCategory = "";
    let rowspan = 1;
    let firstElement: HTMLTableCellElement | null = null;

    elements.forEach((element) => {
      const text = element.textContent;

      if (text === lastCategory) {
        rowspan++;
        element.style.display = "none";
        if (firstElement) {
          firstElement.setAttribute("rowspan", rowspan.toString());
        }
      } else {
        lastCategory = text || "";
        rowspan = 1;
        firstElement = element;
        element.removeAttribute("rowspan");
        element.style.display = "";
      }
    });
  };

  // 설문 제출하기
  function handleSubmitSurvey() {
    let valueStatus = true;
    const answer = [];
    const dLen = storeData.questionsList.length;

    for (let i = 0; i < dLen; i++) {
      const d = storeData.questionsList[i];
      const input = $(`input[name="${d.question_uid}"]${d.type !== 'text' ? ':checked' : ''}`);
      const value = $(input).val();

      valueStatus &&= !!value;
      if (!!!value) {
        $(`#stress-${d.number}`).children('td').not('.category').addClass('focusing');
        $(`#stress-${d.number}`).focus();
      }
      answer[d.number - 1] = { question: { uid: d.question_uid }, answer: $(input).val() };
    }

    // --------------------------
    // HRA 추가 문항 값 가져오기
    // --------------------------
    const q1 = $(`input[name="hra_q1"]:checked`).val();
    const q2 = $(`input[name="hra_q2"]:checked`).val();
    const q3 = $(`input[name="hra_q3"]:checked`).val();
    const q4 = $(`input[name="hra_q4"]:checked`).val();

    let hraValueStatus = true;

    // 기존 focusing 제거
    $(`#hra-1, #hra-2, #hra-3, #hra-4`).children('td').removeClass('focusing');

    if (!q1) {
      hraValueStatus = false;
      $(`#hra-1`).children('td').addClass('focusing');
    }

    if (!q2) {
      hraValueStatus = false;
      $(`#hra-2`).children('td').addClass('focusing');
    }

    if (!q3) {
      hraValueStatus = false;
      $(`#hra-3`).children('td').addClass('focusing');
    }

    if (!q4) {
      hraValueStatus = false;
      $(`#hra-4`).children('td').addClass('focusing');
    }

    // 4번이 그렇다(Y)일 때만 추가 입력 검사
    if (q4 === 'Y') {
      if (!relation || !String(relation).trim()) {
        hraValueStatus = false;
        alert('직계가족 관계를 선택해주세요.');
        return;
      }

      if (!age || !String(age).trim()) {
        hraValueStatus = false;
        alert('발병 연령을 입력해주세요.');
        return;
      }

      if (!disease || !String(disease).trim()) {
        hraValueStatus = false;
        alert('질환을 선택해주세요.');
        return;
      }
    }


    if (!valueStatus) {
      alert("문항에 대한 응답을 모두 선택해주세요.");
      return;
    }

    if (!hraValueStatus) {
      alert('뇌심혈관질환 문항에 대한 응답을 모두 선택해주세요.');
      return;
    }

    const requestBody = {
      family: {
        id: localStorage.getItem('ownerFamID')
      },
      QnAs: answer,
      year: new Date().getFullYear(),
      uid: location.state.assigned_uid,
      hra: {
        q1: q1,
        q2: q2,
        q3: q3,
        q4: q4,
        relation: q4 === 'Y' ? relation : null,
        age: q4 === 'Y' ? age : null,
        disease: q4 === 'Y' ? disease : null
      }
    };

    LodingData(() =>
        api.post(`customer/api/v2/surveys/assigns/${location.state.assigned_uid}`, requestBody)
            .then(res => {
              if (res.data.success === false) {
                alert(res.data.message);
                return;
              }
              alert('저장되었습니다.');
              navigate('/stress');
            })
            .catch(err => {
              console.log(err);
            })
    );
  }

  // 포커스
  function handleChange(e: any) {
    if (!$(e).is(":checked")) {
      $(e.target).closest('td').removeClass('focusing');
      $(e.target).closest('td').siblings().removeClass('focusing');
    }
  }


  return (
    <Container className="container" sx={{ mb: 5 }}>
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
              직무스트레스
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              한국인 직무 스트레스 측정도구(Korean Occupational Stress Scale: KOSS)
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ width: 1500 }}>
        <TableContainer className="White_box">
          <Table size="small" className="Cl_table" sx={{ whith: '100%', '& td': { borderRight: '1px solid #ccc', cursor: 'default', '& input': { cursor: "pointer" } } }}>
            <TableHead>
              <TableRow>
                <TableCell>구분</TableCell>
                <TableCell sx={{ width: 50 }}>#</TableCell>
                <TableCell>내용</TableCell>
                <TableCell sx={{ width: 110 }}>전혀<br />그렇지 않다</TableCell>
                <TableCell sx={{ width: 110 }}>그렇지 않다</TableCell>
                <TableCell sx={{ width: 110 }}>그렇다</TableCell>
                <TableCell sx={{ width: 110 }}>매우 그렇다</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                storeData.questionsList && storeData.questionsList.map((item: any, idx: number) => {
                  return (
                    <TableRow key={idx} id={`stress-${item.number}`}>
                      <TableCell className="category">{item.category}</TableCell>
                      <TableCell>{item.number}</TableCell>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.strongly_disagree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.disagree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.agree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                      <TableCell>
                        <Input name={item.question_uid} type={item.type} value={item.strongly_agree} onChange={handleChange} sx={{ '&::before': { border: '0px solid #ccc' } }} />
                      </TableCell>
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </Table>

          <Typography sx={{ textAlign: 'center', mt: 4, mb: 4 }}>뇌심혈관질환 발병위험도 평가</Typography>
          
          <Table size="small" className="Cl_table hm_table" sx={{
                width: '100%',
                ml: 'auto',
                mr: 'auto',
                bgcolor: '#fff',
                borderRadius: 0,
                borderCollapse: 'collapse',
                border: '1px solid #cfcfcf',
                '& .MuiTableCell-root': {
                  border: '1px solid #cfcfcf',
                  padding: '10px !important',
                  fontSize: 14,
                  color: '#222'
                }
              }}>
            <TableHead
                sx={{
                  '& th': {
                    bgcolor: '#e7e7e7',
                    fontWeight: 700,
                    textAlign: 'center',
                    border: '1px solid #cfcfcf',
                    padding: '10px !important',
                    lineHeight: 1.2
                  }
                }}
            >
              <TableRow>
                <TableCell width={45}>No</TableCell>
                <TableCell>내용</TableCell>
                <TableCell width={65}>그렇다</TableCell>
                <TableCell width={65}>아니다</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow id="hra-1">
                <TableCell sx={{ textAlign: 'center' }}>1</TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  현재 흡연 중이다.
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <input type="radio" name="hra_q1" value="Y" />
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <input type="radio" name="hra_q1" value="N" />
                </TableCell>
              </TableRow>

              <TableRow id="hra-2">
                <TableCell sx={{ textAlign: 'center' }}>2</TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  1주일에 3일 이상의 신체활동을 한다.
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <input type="radio" name="hra_q2" value="Y" />
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <input type="radio" name="hra_q2" value="N" />
                </TableCell>
              </TableRow>

              <TableRow id="hra-3">
                <TableCell sx={{ textAlign: 'center' }}>3</TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  1일 30분 이상의 신체활동을 한다.
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <input type="radio" name="hra_q3" value="Y" />
                </TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  <input type="radio" name="hra_q3" value="N" />
                </TableCell>
              </TableRow>

              <TableRow id="hra-4">
                <TableCell sx={{ textAlign: 'center' }}>4</TableCell>
                <TableCell sx={{ textAlign: 'center' }}>
                  직계가족의 심혈관질환 조기 발병(65세 이전)에 해당사항이 있다.
                </TableCell>

                <TableCell sx={{ textAlign: 'center' }}>
                  <input
                      type="radio"
                      name="hra_q4"
                      value="Y"
                      onChange={(e) => setHraQ4(e.target.value)}
                  />
                </TableCell>

                <TableCell sx={{ textAlign: 'center' }}>
                  <input
                      type="radio"
                      name="hra_q4"
                      value="N"
                      onChange={(e) => setHraQ4(e.target.value)}
                  />
                </TableCell>
              </TableRow>

              {hraQ4 === 'Y' && (
                  <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
                    <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          gap: 0.5,
                        }}
                    >
                      {/* 관계 선택 */}
                      <Select
                          size="small"
                          value={relation}
                          onChange={(e) => setRelation(e.target.value)}
                          sx={{ minWidth: 90 }}
                      >
                        <MenuItem value="직계가족">직계가족</MenuItem>
                        <MenuItem value="할아버지">할아버지</MenuItem>
                        <MenuItem value="할머니">할머니</MenuItem>
                        <MenuItem value="아버지">아버지</MenuItem>
                        <MenuItem value="어머니">어머니</MenuItem>
                        <MenuItem value="형제">형제</MenuItem>
                        <MenuItem value="자매">자매</MenuItem>
                        <MenuItem value="아들">아들</MenuItem>
                        <MenuItem value="딸">딸</MenuItem>
                      </Select>

                      <Typography sx={{ fontSize: 16, lineHeight: 1, mr:2, fontWeight: 'bold' }}>
                        (이)가
                      </Typography>

                      <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.3,
                          }}
                      >
                        <TextField
                            variant="outlined"
                            size="small"
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                            placeholder="ex) 50"
                            sx={{
                              width: 80,
                              '& .MuiInputBase-input': {
                                py: 0.8,
                                textAlign: 'center',
                                fontSize: 16,
                              },
                            }}
                        />
                        <Typography sx={{ fontSize: 16, lineHeight: 1, fontWeight: 'bold'}}>
                          세경
                        </Typography>
                      </Box>

                      <RadioGroup row value={disease} onChange={(e) => setDisease(e.target.value)}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            ml: 1,
                          }}
                      >
                        <FormControlLabel
                            value="뇌졸중"
                            control={<Radio size="small" />}
                            label="뇌졸중"
                            sx={{
                              m: 0,
                              alignItems: 'center',
                              '& .MuiFormControlLabel-label': {
                                fontSize: 16,
                                lineHeight: 1,
                              },
                            }}
                        />
                        <FormControlLabel
                            value="협심증"
                            control={<Radio size="small" />}
                            label="협심증"
                            sx={{
                              m: 0,
                              alignItems: 'center',
                              '& .MuiFormControlLabel-label': {
                                fontSize: 16,
                                lineHeight: 1,
                              },
                            }}
                        />
                        <FormControlLabel
                            value="심근경색증"
                            control={<Radio size="small" />}
                            label="심근경색증"
                            sx={{
                              m: 0,
                              alignItems: 'center',
                              '& .MuiFormControlLabel-label': {
                                fontSize: 16,
                                lineHeight: 1,
                              },
                            }}
                        />
                      </RadioGroup>

                      <Typography sx={{ fontSize: 16, lineHeight: 1, ml: 1, fontWeight: 'bold'}}>
                        발병
                      </Typography>
                    </Box>
                  </TableCell>
              )}
            </TableBody>
          </Table>
          
        </TableContainer>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{ color: 'red' }}>! 제출 후에는 수정할 수 없습니다.</Typography>
        <Button variant="contained" onClick={handleSubmitSurvey} sx={{ mt: 2, background: '#0d6703', borderRadius: 20, width: '20%', '&:hover': { background: '#074300' } }}>제출하기</Button>
      </Box>

      <Bottom />
    </Container>
  )
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}
export default StressAnswer;